import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {Steueridentifikation} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-steueridentifikation',
  templateUrl: './steueridentifikation.component.html'
})
export class SteueridentifikationComponent extends FormBaseComponent<Steueridentifikation> {

  @Input() showWirtschaftsIdNummer = true;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      steueridentifikationsnummer: [this.data.steueridentifikationsnummer, [
        this.validatorService.pattern('^[0-9]{11}$',
          this.translateService.instant('COMMON_UI.VALIDATION.STEUERIDENTIFIKATIONSNUMMER_INVALID_PATTERN'))
      ]],
      wirtschaftsIdNummer: [this.showWirtschaftsIdNummer ? this.data.wirtschaftsIdNummer : null, [
        this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
          this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
      ]]
    });
  }
}
